// extracted by mini-css-extract-plugin
export var askAiIcon = "_kk-9";
export var container = "_kk-0";
export var groupSeparator = "_kk-a";
export var highlight = "_kk-4";
export var resultIcon = "_kk-5";
export var resultItem = "_kk-7";
export var resultSubtitle = "_kk-3";
export var resultTitle = "_kk-2";
export var resultsList = "_kk-1";
export var searchGroup = "_kk-6";
export var selected = "_kk-8";